import { AbstractDocument, Identifiable, Timestampable } from '../../../../abstract/Document';
import { AbstractCollection } from '../../../../abstract/Collection';
import type { WithFieldValue } from 'firebase/firestore';
import { Identified, PartialMaybe, Timestamped } from '../../../../abstract/_';
import type { IEventBroadcastMessage } from './BroadcastMessages.types';
import type { Event } from '../Events';

@Identifiable
@Timestampable
export class BroadcastMessage extends AbstractDocument<IEventBroadcastMessage> {
  readonly collections = {};

  get event() {
    return this.reference.parent.parent!.id;
  }
}

export class BroadcastMessages extends AbstractCollection<BroadcastMessage, IEventBroadcastMessage> {
  static path = 'broadcast-messages';

  constructor(document: Event) {
    super(document.collection(BroadcastMessages.path), BroadcastMessage);
  }

  get event() {
    return this.reference.parent!.id;
  }

  async create(data: WithFieldValue<PartialMaybe<IEventBroadcastMessage, Identified & Timestamped>>): Promise<BroadcastMessage> {
    return await this.push().create(data as IEventBroadcastMessage);
  }
}
